export default {
  getTableSettings: (state) => state.tableSettings,
  getVehicleRequestGroupsTable: (state) => state.vehiceRequestGroupsTable,
  getIsTableLoading: (state) => state.isTableLoading,
}
